import hash from "object-hash"
import storage from "../../helpers/storage"
import { StorageLabel } from "../../../mp-utils/generic-utils"
import { ImpersonatedUserDataType, OriginalUserDataType } from "../types"

export const IMPERSONATED_USER_DATA = "IMPERSONATED_USER_DATA"

export const setImpersonatedUserData = (data: ImpersonatedUserDataType) => {
  storage.set(IMPERSONATED_USER_DATA, JSON.stringify(data))
}

export const getImpersonatedUserData = (): ImpersonatedUserDataType => {
  return JSON.parse(storage.get(IMPERSONATED_USER_DATA) || "{}")
}

export const removeImpersonatedUserData = () => {
  storage.remove(IMPERSONATED_USER_DATA)
}

export const ORIGINAL_USER_DATA = "ORIGINAL_USER_DATA"

export const setOriginalUserData = (data: OriginalUserDataType) => {
  storage.set(ORIGINAL_USER_DATA, JSON.stringify(data))
}

export const getOriginalUserData = (): OriginalUserDataType => {
  return JSON.parse(storage.get(ORIGINAL_USER_DATA) || "{}")
}

export const removeOriginalUserData = () => {
  storage.remove(ORIGINAL_USER_DATA)
}

export const ENTERING_IMPERSONATION_FLAG = "ENTERING_IMPERSONATION_FLAG"

export const setEnteringImpersonationFlag = (value: boolean) => {
  storage.set(ENTERING_IMPERSONATION_FLAG, value)
}

export const getEnteringImpersonationFlag = (): boolean => {
  return JSON.parse(storage.get(ENTERING_IMPERSONATION_FLAG) || "false")
}

export const removeEnteringImpersonationFlag = () => {
  storage.remove(ENTERING_IMPERSONATION_FLAG)
}

export const EXITING_IMPERSONATION_FLAG = "EXITING_IMPERSONATION_FLAG"

export const setExitingImpersonationFlag = (value: boolean) => {
  storage.set(EXITING_IMPERSONATION_FLAG, value)
}

export const getExitingImpersonationFlag = (): boolean => {
  return JSON.parse(storage.get(EXITING_IMPERSONATION_FLAG) || "false")
}

export const removeExitingImpersonationFlag = () => {
  storage.remove(EXITING_IMPERSONATION_FLAG)
}

export const setCurrentUserForImpersonationLogin = (
  data: ImpersonatedUserDataType | OriginalUserDataType
) => {
  localStorage.setItem(
    StorageLabel.USER,
    JSON.stringify({
      id: data.userId,
      role: data.userRole,
      loginToken: data.customToken
    })
  )

  localStorage.setItem(
    StorageLabel.USER_TOKEN,
    hash({
      id: data.userId,
      role: data.userRole,
      loginToken: data.customToken
    })
  )
}

export const removeAllImpersonationKeys = () => {
  removeImpersonatedUserData()
  removeOriginalUserData()
  removeEnteringImpersonationFlag()
  removeExitingImpersonationFlag()
}

export const checkImpersonationTransition = (): boolean => {
  const isExitingImpersonation = getExitingImpersonationFlag()
  const isEnteringImpersonation = getEnteringImpersonationFlag()

  return isExitingImpersonation || isEnteringImpersonation
}
